import { NS_SVG } from "../constants";
import { SVG_SetDash } from "./SVG_SetDash";
import { SVG_ShiftX } from "./SVG_ShiftX";
import { SVG_ShiftY } from "./SVG_ShiftY";

export function SVG_DrawLine(
  x1,
  y1,
  x2,
  y2,
  lineColor,
  thickness,
  dashed,
  lineOpacity,
  svgElement
) {
  x1 = SVG_ShiftX(x1, svgElement);
  x2 = SVG_ShiftX(x2, svgElement);
  y1 = SVG_ShiftY(y1, svgElement);
  y2 = SVG_ShiftY(y2, svgElement);

  var lineObj = document.createElementNS(NS_SVG, "line");
  lineObj.setAttribute("x1", x1);
  lineObj.setAttribute("y1", y1);
  lineObj.setAttribute("x2", x2);
  lineObj.setAttribute("y2", y2);
  lineObj.setAttribute("stroke", lineColor);
  lineObj.setAttribute("stroke-width", thickness);
  if (lineOpacity) lineObj.setAttribute("stroke-opacity", lineOpacity);

  if (dashed) {
    //	if (wideDash)
    SVG_SetDash(thickness, lineObj);
    //	else
    //		lineObj.setAttribute("stroke-dasharray", "1,1");
  }

  svgElement.appendChild(lineObj);
}
